<isophi-info-popup
  *transloco="let t"
  [title]="t('shared/managementApp')"
  [continueLabel]="t('management/popup/continue')"
  [(dontShowAgain)]="dontShowAgain"
  (closed)="close()"
>
  <div class="inner-wrapper">
    <div class="text-wrapper">
      <div [innerHTML]="t('management/popup/text1')"></div>
      <div [innerHTML]="t('management/popup/text2')"></div>
      <div [innerHTML]="t('management/popup/text3')"></div>
      <div [innerHTML]="t('shared/popup/contact')"></div>
    </div>
    <img src="https://skolka.online/wp-content/uploads/2024/06/img_iphone-v2-min.png" alt="" />
  </div>
</isophi-info-popup>
